(function() {
  function onReady(fn){
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  onReady(function(){
    var wrap = document.getElementById('rainier-variant-button');
    if (!wrap) return;

    var allowedIds = (wrap.dataset.variantIds || '')
      .split(',').map(function(s){ return s.trim(); }).filter(Boolean);
    // If you only place this on the product that needs it, we can ignore productId guard
    // var targetProductId = wrap.dataset.productId || null;

    // Always resolve form & id input fresh (Impulse replaces nodes on change)
    function resolveForm() {
      var section = wrap.closest('section[id^="MainProduct-"], section[id^="ProductSection-"], .product, .Product, .product-section') || document;
      var form = section.querySelector('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
      return { section: section, form: form };
    }

    function getCurrentVariantId() {
      // 1) Prefer URL param — Impulse updates it on every change
      var m = window.location.search.match(/[?&]variant=(\d+)/);
      if (m) return m[1];

      // 2) Fallback: fresh query for hidden input each time
      var ctx = resolveForm();
      var idInput = ctx.form ? ctx.form.querySelector('input[name="id"]') : null;
      return idInput && idInput.value ? String(idInput.value) : '';
    }

    function update() {
      var currentId = getCurrentVariantId();
      var variantMatches = currentId && allowedIds.indexOf(String(currentId)) > -1;
      wrap.style.display = variantMatches ? '' : 'none';
    }

    // Initial
    update();

    // Listen broadly; always re-check via URL/ fresh query
    var ctx = resolveForm();

    if (ctx.form) {
      ctx.form.addEventListener('change', function(e){
        if (e.target && (e.target.matches('select[name^="options"]') || e.target.matches('input[name^="options"]'))) {
          // Let theme finish its DOM swap/history push
          setTimeout(update, 0);
        }
      });

      // Observe form subtree for node replacements (hidden id input swaps)
      new MutationObserver(function(){ setTimeout(update, 0); })
        .observe(ctx.form, { childList: true, subtree: true, attributes: true });
    }

    // Theme custom events
    document.addEventListener('variant:change', function(){ setTimeout(update, 0); });
    document.addEventListener('variant:changed', function(){ setTimeout(update, 0); });

    // URL/history changes
    window.addEventListener('popstate', update);

    // Theme editor lifecycle (keeps preview stable)
    ['shopify:section:load','shopify:section:select','shopify:section:deselect','shopify:block:select','shopify:block:deselect']
      .forEach(function(evt){ document.addEventListener(evt, function(){ setTimeout(update, 0); }); });
  });
})();
